import styled, { css, keyframes } from 'styled-components';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 36px 72px;
`;

export const StyledAddDependentsContainer = styled.div`
    margin-top: 26px;
`;

export const EnrollMembersContainer = styled.div`
    display: flex;
    margin-bottom: 16px;
    width: 100%;
    flex-wrap: wrap;
    gap: 24px;
    box-sizing: border-box;
    @media (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
        flex-direction: column;
        gap: 12px;
        background-color: ${(p) => p.theme.colors.white};
        padding: 24px 20px;
        margin: 0px;
    }
`;

export const StyledWarning = styled.div`
    border-radius: 10px;
    max-width: 860px;
    margin: 8px 0px;
    @media (max-width: 768px) {
        margin: 0px 20px;
    }
`;

export const StyledSpacing = styled.div`
    width: fit-content;
    margin: 20px 0px;
    @media (max-width: 768px) {
        margin: 0px 20px 12px 20px;
    }
`;

export const StyledLoaderContainer = styled.div`
    margin-top: 42px;
`;

export const StyledMemberSectionHeader = styled.div<{ $isUpgraded: boolean }>`
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    ${(p) =>
        p.$isUpgraded
            ? `
                width: 100%;
                background: linear-gradient(to right, #c9eacf 10%, transparent);
                border-radius: 4px;
                padding: 8px 16px;
                z-index: 1;
                position: relative;
    `
            : ''}
`;

export const StyledMemberSectionHeaderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledModularValidationDependentModal = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 500px;
`;

export const StyledModularValidationDependentModalBody = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-sizing: border-box;
    align-items: center;
    text-align: center;
`;

export const StyledModularValidationDependentModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 8px;
    padding: 12px 16px;
    text-align: start;
    width: 100%;
    box-sizing: border-box;
    background-color: ${(p) => p.theme.colors.surface0};
`;

export const StyledModularValidationDependentModalContentText = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const StyledModularValidationDependentModalFooter = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    padding: 16px 32px;
    border-top: 0.5px solid ${({ theme }) => theme.colors.seafoamGray};
`;

const StyledMinimizeFadeOutAnimation = keyframes`
    from {height: 100%;}
    to {
        height: 20px;
        opacity: 0;
    }

`;

export const StyledRelationMembersContainer = styled.div<{ $animate: boolean }>(({ $animate }) =>
    $animate
        ? css`
              box-sizing: border-box;
              width: 100%;
              position: relative;
              &::before {
                  content: 'a';
                  color: transparent;
                  position: absolute;
                  top: -8px;
                  left: -8px;
                  width: calc(100% + 16px);
                  height: calc(100% + 16px);
                  background: linear-gradient(to right, #c9eacf 10%, transparent);
                  border-radius: 12px;
                  animation: ${StyledMinimizeFadeOutAnimation} 0.7s 1 ease-in;
                  animation-fill-mode: forwards;
                  animation-delay: 2s;
                  pointer-events: none;
              }
          `
        : ''
);
